import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('inventoryItemStore', 'inventoryProductStore', 'inventorySupplierStore', 'stationStore')
@observer
class InventoryItemModify extends Component {
  render() {
    const { stationStore, inventoryItemStore, inventoryProductStore, inventorySupplierStore, params } = this.props;

    return (
      <ItemModify
        title='Item'
        slug='/inventory/item'
        store={inventoryItemStore}
        itemFields={[
          { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
          { label: 'Serial No', key: 'serial_no', type: 'text'},
          { label: 'Product', key: 'product_id', type: 'select', options: inventoryProductStore.items,  fields:{label: 'name', value: 'id'}  },
          { label: 'Purchase Date', key: 'purchase_date', type: 'date' },
          { label: 'Warranty Date', key: 'warranty_date', type: 'date' },
          { label: 'Calibration Date', key: 'calibration_date', type: 'date' },
          { label: 'Next Calibration Date', key: 'next_calibration_date', type: 'date' },
          { label: 'Installation Date', key: 'installation_date', type: 'date' },
          { label: 'Station', key: 'station_id', type: 'select', options: stationStore.items.sort((a,b) => a.name.toLowerCase()<b.name.toLowerCase()?-1:1),  fields:{label: 'name', value: 'id'}  },
          { label: 'Present Location', key: 'present_location', type: 'text'},
          { label: 'Supplier', key: 'supplier_id', type: 'select', options: inventorySupplierStore.items,  fields:{label: 'name', value: 'id'}  },
        ]}
        params={params}
      />
    );
  }
}

export default InventoryItemModify;



// WEBPACK FOOTER //
// ./src/components/Inventory/InventoryItemModify.js